import { createContext, type ReactNode, useContext } from 'react'

export type UiLabels = {
  select: string
  selectOption: string
  noOptions: string
  more: string
  search: string
  export: string
  copied: string
  loading: string
  noData: string
  breadcrumb: string
  closeSortMenu: string
  sliderFrom: string
  sliderTo: string
  unlock: string
  footerAbout: string
  footerContact: string
  reportDamage: {
    error: string
    lastKnownPartner: string
    unknownPartner: string
    goTo: string
    insurer: string
    registerDamage: string
    customerServicePhone: string
  }
  lostFuelCard: {
    noProducts: string
    closeWindow: string
    error: string
    sending: string
    success: string
    intro: string
    registrationNumber: string
    registrationNumberRequired: string
    productType: string
    productTypeRequired: string
    selectProduct: string
    address: string
    addressRequired: string
    postalCode: string
    postalCodeRequired: string
    city: string
    cityRequired: string
    comment: string
    commentPlaceholder: string
    order: string
  }
}

export const DEFAULT_UI_LABELS: UiLabels = {
  select: 'Velg',
  selectOption: 'Velg et alternativ',
  noOptions: 'Ingen alternativer tilgjengelig',
  more: 'til',
  search: 'Søk...',
  export: 'Eksporter',
  copied: 'Kopiert!',
  loading: 'Henter data...',
  noData: 'Ingen data tilgjengelig...',
  breadcrumb: 'Brødsmulesti',
  closeSortMenu: 'Lukk sorteringsmeny',
  sliderFrom: 'Fra',
  sliderTo: 'Til',
  unlock: 'Lås opp',
  footerAbout: 'Om Autoplan',
  footerContact: 'Kontakt oss',
  reportDamage: {
    error: 'Noe gikk galt...',
    lastKnownPartner: 'Din forsikringspartner som sist var kjent for oss er',
    unknownPartner: 'Ukjent',
    goTo: 'Gå til',
    insurer: 'forsikringsselskapet',
    registerDamage: 'for å registrere skaden, eller ring kundeservice.',
    customerServicePhone: 'Telefonnummer Kundeservice',
  },
  lostFuelCard: {
    noProducts: 'Du har ingen kort eller brikker som kan bestilles.',
    closeWindow: 'Lukk vinduet',
    error: 'Noe gikk galt under bestilling av kort/brikke. Prøv igjen senere eller kontakt Autoplan.',
    sending: 'Sender forespørsel...',
    success: 'Nytt kort/brikke er bestilt!',
    intro: 'Kortet/brikken vil bli sendt til din registrerte adresse.',
    registrationNumber: 'Registreringsnummer',
    registrationNumberRequired: 'Registreringsnummer er obligatorisk',
    productType: 'Type kort/brikke',
    productTypeRequired: 'Type kort/brikke er obligatorisk',
    selectProduct: 'Velg kort eller brikke',
    address: 'Adresse',
    addressRequired: 'Adresse er obligatorisk',
    postalCode: 'Postnummer',
    postalCodeRequired: 'Postnummer er obligatorisk',
    city: 'Poststed',
    cityRequired: 'Poststed er obligatorisk',
    comment: 'Kommentar',
    commentPlaceholder: 'Skriv en kommentar',
    order: 'Bestill',
  },
}

export function UiLabelsProvider({ labels, children }: { labels: UiLabels; children: ReactNode }) {
  return <UiLabelsContext.Provider value={labels}>{children}</UiLabelsContext.Provider>
}

export const useUiLabels = () => useContext(UiLabelsContext)

const UiLabelsContext = createContext<UiLabels>(DEFAULT_UI_LABELS)
